/* import { createContext, useContext, useState } from "react";

const SliderContext = createContext();

export const SliderProvider = ({ children }) => {
  const [sliderStates, setSliderStates] = useState({}); // Store slider states here

  const openSlider = (sliderId) => {
    // Close other sliders, if needed
    const newSliderStates = { ...sliderStates };
    Object.keys(newSliderStates).forEach((id) => {
      newSliderStates[id] = { open: false, expanded: false };
    });
    newSliderStates[sliderId] = { open: true, expanded: true };
    setSliderStates(newSliderStates);
  };

  const closeSlider = (sliderId) => {
    const newSliderStates = { ...sliderStates };
    newSliderStates[sliderId] = { open: false, expanded: false };
    setSliderStates(newSliderStates);
  };

  const setExpandedSlider = (sliderId) => {
    const newSliderStates = { ...sliderStates };
    newSliderStates[sliderId] = {
      open: newSliderStates[sliderId].open,
      expanded: true,
    };
    setSliderStates(newSliderStates);
  };

  const closeSliderOnly = (sliderId) => {
    const newSliderStates = { ...sliderStates };
    newSliderStates[sliderId] = {
      open: false,
      expanded: newSliderStates[sliderId].expanded,
    };
    setSliderStates(newSliderStates);
  };

  const openSliderOnly = (sliderId) => {
    const newSliderStates = { ...sliderStates };
    newSliderStates[sliderId] = {
      open: false,
      expanded: newSliderStates[sliderId].expanded,
    };
    setSliderStates(newSliderStates);
  };

  const registerSlider = (sliderId, itemSlideRef) => {
    setSliderStates((prevStates) => ({
      ...prevStates,
      [sliderId]: { open: false, expanded: false },
    }));
  };

  return (
    <SliderContext.Provider
      value={{
        sliderStates,
        openSlider,
        closeSlider,
        setExpandedSlider,
        closeSliderOnly,
        openSliderOnly,
        registerSlider,
      }}
    >
      {children}
    </SliderContext.Provider>
  );
};

export const useSliderContext = () => useContext(SliderContext);
 */

import * as React from "react";

const EventContext = React.createContext();

function sliderReducer(state, action) {
  switch (action.type) {
    case "addSlider": {
      return {
        ...state,
        sliders: {
          ...state.sliders,
          [action.value]: { open: false, expanded: false },
        },
      };
    }
    /*     case "openSlider": {
      const newSliderStates = { ...state.sliders };
      Object.keys(newSliderStates).forEach((id) => {
        newSliderStates[id] = { open: false, expanded: false };
      });
      newSliderStates[action.value] = { open: true, expanded: true };
      return {
        ...state,
        sliders: newSliderStates,
      };
    } */
    case "closeAllSliders": {
      const newSliderStates = { ...state.sliders };
      Object.keys(newSliderStates).forEach((id) => {
        newSliderStates[id] = { open: false, expanded: false };
      });

      return {
        ...state,
        sliders: newSliderStates,
      };
    }

    case "toggleSlider": {
      const newSliderStates = { ...state.sliders };

      if (action.value.open && action.value.expanded) {
        Object.keys(newSliderStates).forEach((id) => {
          newSliderStates[id] = { open: false, expanded: false };
        });
      }

      if (
        action.value.open !== undefined ||
        action.value.expanded !== undefined
      ) {
        const existingState = newSliderStates[action.value.id] || {
          open: false,
          expanded: false,
        };
        newSliderStates[action.value.id] = {
          open:
            action.value.open !== undefined
              ? action.value.open
              : existingState.open,
          expanded:
            action.value.expanded !== undefined
              ? action.value.expanded
              : existingState.expanded,
        };
      }

      /*      newSliderStates[action.value.id] = {
        open: action.value.open,
        expanded: action.value.expanded,
      }; */

      return {
        ...state,
        sliders: newSliderStates,
      };
    }

    case "setExpandedSlider": {
      const newSliderStates = { ...state.sliders };
      newSliderStates[action.value] = {
        open: newSliderStates[action.value].open,
        expanded: true,
      };

      return {
        ...state,
        sliders: newSliderStates,
      };
    }

    case "closeSliderOnly": {
      const newSliderStates = { ...state.sliders };
      newSliderStates[action.value] = {
        open: false,
        expanded: newSliderStates[action.value].expanded,
      };

      return {
        ...state,
        sliders: newSliderStates,
      };
    }
    case "openSliderOnly": {
      const newSliderStates = { ...state.sliders };
      newSliderStates[action.value] = {
        open: true,
        expanded: newSliderStates[action.value].expanded,
      };

      return {
        ...state,
        sliders: newSliderStates,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function SliderProvider({ children }) {
  const [state, dispatch] = React.useReducer(sliderReducer, {
    sliders: [],
  });
  const value = { state, dispatch };
  return (
    <EventContext.Provider value={value}>{children}</EventContext.Provider>
  );
}

function useSlider() {
  const context = React.useContext(EventContext);
  if (context === undefined) {
    throw new Error("useEvent must be used within a SliderProvider");
  }
  return context;
}

export { SliderProvider, useSlider };
